import React, { useState, useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import DatePicker from "react-datepicker";
import { transactionAPI } from "services";
import TxnList from "./TxnList";
//import { useOnboardingStore } from "store/onboarding-store";
import useUniversalStore from "store/universalStore";
import ExpandableButton from "components/ExpandableButton";
import { toast } from "sonner";

function Home() {
  const { t } = useTranslation();
  const [date, setDate] = useState(new Date());
  //const goToNextStep = useOnboardingStore((state) => state.goToNextStep);
  const write = useUniversalStore((state) => state.write);
  const accountId = useUniversalStore((state) => state.accountId);
  const [animation, setAnimation] = useState("");
  const [hideCancelled, setHideCancelled] = useState(false);

  useEffect(() => {
    fetchTransactions();
  }, [date]);

  const fetchTransactions = async () => {
    var transactions = await transactionAPI.getTransactionsByDate(date);
    write({
      transactions: transactions
    });
  }

  const prevDate = async () => {
    const newDate = dayjs(date).subtract(1, "days").toDate();
    setDate(newDate);
    setAnimation("animate__animated animate__slideInRight fast-animation");
  };

  const nextDate = async () => {
    const today = new Date();
    if (date >= today) return;

    const newDate = dayjs(date).add(1, "days").toDate();
    setDate(newDate);
    setAnimation("animate__animated animate__slideInLeft fast-animation");
  };

  // const handleDate = (year,month,day)=>{
  //   let newDate = new Date(year,month);
  //   console.log("new Date ",newDate);
  //   setDate(newDate);
  // }

  const handleDate = (date) => {
    setDate(date);
  }

  return (
    <>
      <div className="row bg-app py-2">
        <div className="col-1">
          <i className="bi bi-arrow-left-circle-fill fs-2 btn btn-outline-light border-0"
            onClick={prevDate}
          />
        </div>
        <div className="col-10 my-2 d-flex gap-2 justify-content-center">
          <DatePicker
            selected={date}
            onChange={(value) => setDate(value)}
            dateFormat="dd-MM-yyyy"
            maxDate={new Date()}
            className="datePicker"
            showIcon
            icon={<i className="bi bi-calendar-date text-white "></i>}
          />

          <i className={`fs-2 text-white cursor-pointer 
              ${hideCancelled ? "bi-filter-circle-fill" : "bi-filter"}`}
            onClick={() => setHideCancelled(!hideCancelled)}></i>

        </div>
        <div className="col-1" align="right">
          <i className="bi bi-arrow-right-circle-fill fs-2 btn btn-outline-light border-0"
            onClick={nextDate}
            disabled={date >= new Date()}
          />
        </div>
      </div>

      <TxnList
        currentDate={date}
        animation={animation}
        setAnimation={setAnimation}
        hideClosed={hideCancelled} />

      <div className="row position-absolute mb-5 mx-5 bottom-0 end-0">
        <ExpandableButton
          title="New Entry"
          formId="newTxn"
          // onClick={(e) => goToNextStep()}
          icon="bi bi-pencil-fill"
        />
      </div>
    </>
  );
}

export default Home;
